// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "tehosmotr #id_avtoid,\ntehosmotr #id_pricepid,\ntehosmotr #id_id {\n  width: 150px;\n  height: 250px;\n}\ntehosmotr #id_tehosmdata,\ntehosmotr #id_tehosmdata1,\ntehosmotr datepicker input {\n  width: 150px;\n}\ntehosmotr #id_avtoid .late,\ntehosmotr #id_pricepid .late {\n  background: #AA0022;\n  color: #FFFFFF;\n}\ntehosmotr button.big {\n  width: 150px;\n}\ntehosmotr button.fat {\n  width: 150px;\n  height: 35px;\n}", ""]);
// Exports
module.exports = exports;
